import React, {useState} from 'react';
import {Button, Stack} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {finalize} from 'rxjs';
import {useSnackbar} from 'notistack';
import {useObservable} from '@ngneat/react-rxjs';

import {suppliersQuery, suppliersService} from '@store/suppliers';

import {Download} from '@icons/index';
import SuppliersListTable from '@screens/admin/suppliers/list/SuppliersList.table';

const SuppliersListTab = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {enqueueSnackbar} = useSnackbar();

  const [CSVLoading, setCSVLoading] = useState(false);

  const [filterStatus] = useObservable(suppliersQuery.status$);
  const [selectedSuppliers] = useObservable(suppliersQuery.selectedSuppliers$);

  const handleExportCSV = () => {
    setCSVLoading(true);
    suppliersService.getSuppliersCSV()
      .pipe(finalize(() => setCSVLoading(false)))
      .subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <Stack flex={1} width="100%" spacing={2} mt="-35px">
      <Stack alignSelf="flex-end" direction="row" alignItems="center" spacing={2}>
        <Button
          variant="outlined" color="primary"
          disabled={CSVLoading}
          onClick={handleExportCSV}
          startIcon={<Download/>}>
          {t('global.exportCSV')}
        </Button>
      </Stack>
      <Stack flex={1} spacing={3}>
        <Stack flex={1}>
          <SuppliersListTable/>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SuppliersListTab;
